<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/en">Exhibition List</a><span>/</span>
          <em name="Exhibition"></em> <span>/</span>
          <a href="javascript: history.back()">Products</a> <span>/</span> Add
          Products
        </div>
        <div>
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <article>
      <div>
        <div
          class="contentBoxStatus"
          style="border-radius: 5px; padding-bottom: 20px"
        >
          <h1>Add Products</h1>
          <p class="my-3">&nbsp;</p>

          <div>
            <div
              class="alert"
              v-if="ProductWarning == 'N/A'"
              name="ProductWarning"
            >
              <div>
                <i class="fas fa-exclamation-circle mr-1"></i>
                The product information you create must comply with the
                regulations of the relevant organization. If there is any
                dispute, the organizer reserves the right to decide the final
                product to be put on the shelf.
              </div>
              <div class="mt-1">
                <i class="fas fa-exclamation-circle mr-1"></i>
                Please make sure all the information required of the product and
                picture are completed, and then click "Submit" to proceed.
              </div>
            </div>
            <div
              class="alert"
              v-else-if="ProductWarning !== 'N/A'"
              name="ProductWarning"
            >
              <div>
                <i class="fas fa-exclamation-circle mr-1"></i>
                {{ ProductWarning }}
              </div>
              <div class="mt-1">
                <i class="fas fa-exclamation-circle mr-1"></i>
                Please make sure all the information required of the product and
                picture are completed, and then click "Submit" to proceed.
              </div>
            </div>
          </div>
        </div>
        <p class="my-3 PcDevice">&nbsp;</p>

        <form
          name="_method"
          id="form"
          enctype="multipart/form-data"
          @submit.prevent="AddEnNewProduct"
        >
          <input type="hidden" name="RegNo" value="" />
          <!-- left -->
          <!-- PC版圖片顯示 -->

          <div class="proLeft PcDevice">
            <div
              class="contentBoxStatus"
              style="border-radius: 5px; padding-bottom: 20px"
            >
              <div
                class="mt-2 mb-3 border text-center py-2"
                style="border-radius: 30px"
              >
                <div class="d-flex align-items-center justify-content-center">
                  <span
                    v-if="modelEnSrc !== noImageEnSrc"
                    class="complete mr-1"
                  ></span>
                  <span v-else class="uncomplete mr-1"></span>
                  <span style="color: black">Upload Image </span>
                </div>
              </div>

              <label class="inputFile">
                <div class="squareThumb pointer ImgHoverStyle">
                  <div
                    class="squareThumb pointer ImgHoverStyle"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="請選擇圖片"
                    v-if="hasImgfile"
                  >
                    <img :src="modelEnSrc" class="img-fluid" />
                  </div>

                  <div
                    class="squareThumb pointer ImgHoverStyle"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="請選擇圖片"
                    v-else
                  >
                    <img
                      src="../../../assets/images/default.jpg"
                      class="img-fluid"
                    />
                  </div>
                </div>
                <span name="showName" class="nowrap"></span>

                <input
                  type="file"
                  accept=".jpg,.jpeg,.webp"
                  class="textStyle maxText"
                  @change="uploadImgPC($event)"
                />
                <p class="divider"></p>

                <div class="d-flex justify-content-around">
                  <div>
                    <p class="align_c">
                      <span class="btnStyle btnGray">Select Image</span>
                    </p>
                  </div>
                  <div v-if="modelEnSrc !== noImageEnSrc">
                    <p class="align_c">
                      <span class="btnStyle btnRed" @click.prevent="resetEnImg"
                        >Reset Image</span
                      >
                    </p>
                  </div>
                </div>
              </label>
              <p class="my-3">&nbsp;</p>
              <p class="italic">File Size：Maximum 3MB</p>
              <p class="italic">File Format：JPG、WEBP</p>
              <p class="italic">Pixel Size：Minimum 500 x 500 Pixel</p>
            </div>
          </div>
          <!-- 行動版圖片顯示 -->

          <div class="contentBoxStatus MbDevice">
            <div class="proLeft">
              <label class="inputFile pointer">
                <!-- <div class="squareThumb">
                  <img :src="modelEnSrc" class="img-fluid" />
                </div> -->

                <div class="squareThumb" v-if="hasImgfile">
                  <img :src="modelEnSrc" class="img-fluid" />
                </div>
                <div class="squareThumb" v-else>
                  <img src="@/assets/images/default.jpg" class="img-fluid" />
                </div>
                <input
                  type="file"
                  accept=".jpg,.jpeg,.webp"
                  class="textStyle maxText"
                  @change="uploadImgMb($event)"
                />
                <p class="divider"></p>
                <div class="d-flex justify-content-around">
                  <p class="align_c">
                    <span class="btnStyle btnGray">Select</span>
                  </p>
                  <div v-if="modelEnSrc !== noImageEnSrc">
                    <p class="align_c">
                      <span class="btnStyle btnRed" @click.prevent="resetEnImg"
                        >Reset
                      </span>
                    </p>
                  </div>
                </div>
              </label>
              <p class="my-3">&nbsp;</p>
              <p class="italic">File Size：Maximum 3MB</p>
              <p class="italic">File Format：JPG、WEBP</p>
              <p class="italic">Pixel Size：Minimum 500 x 500 Pixel</p>
            </div>
          </div>

          <!-- left end -->
          <!-- right -->
          <div class="proRight">
            <div
              class="contentBoxStatus"
              style="border-radius: 5px; padding-bottom: 20px"
            >
              <div
                class="mt-2 mb-3 border text-center py-2 PcDevice"
                style="border-radius: 30px"
              >
                <div class="d-flex align-items-center justify-content-center">
                  <span
                    v-if="!optionCatNo || !eProName || !eProDesc"
                    class="uncomplete mr-1"
                  ></span>
                  <span v-else class="complete mr-1"></span>
                  <span style="color: black">Product Information </span>
                </div>
              </div>

              <p class="formTitle">Display</p>
              <div class="form-check-inline">
                <div class="formstatus">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="Radios"
                    id="yes"
                    :true-value="1"
                    v-model="productArchive"
                    value="0"
                  />
                  <label class="form-check-label" for="yes"> Show</label>
                </div>
                <div class="ml-2">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="Radios"
                    id="no"
                    :true-value="0"
                    v-model="productArchive"
                    value="1"
                  />
                  <label class="form-check-label" for="no"> Hide </label>
                </div>
              </div>
              <p class="my-3">&nbsp;</p>
              <p class="formTitle">Product Name<span class="red">*</span></p>

              <div class="langTip">
                <input
                  type="text"
                  name="eProName"
                  class="textStyle maxText"
                  placeholder="English"
                  v-model="eProName"
                  required
                />
                <span>EN</span>
              </div>

              <div v-if="LocalExh">
                <p class="divider"></p>
                <div class="langTip">
                  <input
                    type="text"
                    name="ProName"
                    class="textStyle maxText"
                    placeholder="Chinese"
                    v-model="ProName"
                  />
                  <span>CN</span>
                </div>
              </div>
              <p class="my-3">&nbsp;</p>
              <div class="right">
                <p class="formTitle">Model</p>
                <input
                  type="text"
                  name="ProModel"
                  class="textStyle maxText mb-3"
                  maxlength="50"
                  v-model="ProModel"
                />
              </div>
              <div class="left">
                <p class="formTitle">Category <span class="red">*</span></p>
                <div v-if="HasSubCategory">
                  <div v-if="showCategory">
                    <div class="d-flex align-items-center">
                      <div>
                        {{ showCategory }}
                      </div>

                      <div
                        class="btn btn-outline-info ml-2 py-1"
                        @click="OpenCategoryModal"
                      >
                        Edit
                      </div>
                    </div>
                  </div>
                  <div
                    v-else-if="!showCategory"
                    class="btn btn-outline-info py-2 mt-1"
                    @click="OpenCategoryModal"
                  >
                    Select Product Category
                  </div>
                </div>
                <div v-else-if="!HasSubCategory">
                  <select
                    class="form-control text-dark"
                    v-model="optionCatNo"
                    required
                  >
                    <option value="">-- Select --</option>
                    <option
                      v-for="item in ProductCategory"
                      :value="item.MainCategoryId"
                    >
                      {{ item.MainCategoryNameEn }}
                    </option>
                  </select>
                </div>
              </div>
              <p class="clear"></p>

              <p class="my-3">&nbsp;</p>

              <p class="formTitle">
                Description (English)<span class="red">*</span>
              </p>
              <textarea
                name="eProDesc"
                rows="6"
                class="maxText textStyle"
                placeholder="English"
                v-model="eProDesc"
                required
              ></textarea>

              <div v-if="LocalExh">
                <p class="my-3">&nbsp;</p>
                <p class="formTitle">Description (Chinese)</p>
                <textarea
                  name="ProDesc"
                  rows="6"
                  class="maxText textStyle"
                  placeholder="Chinese"
                  v-model="ProDesc"
                ></textarea>
              </div>
            </div>
          </div>
          <!-- right end -->
          <p class="clear"></p>
          <div class="PcDevice">
            <p class="my-3">&nbsp;</p>
          </div>

          <div class="text-center PcDevice">
            <button class="btn btn-lg btn-primary mr-4" type="submit">
              Submit
            </button>
            <button
              class="btn btn-lg btn-secondary"
              @click.prevent="backProPage"
            >
              Back
            </button>
          </div>

          <div class="text-center MbDevice mb-4">
            <button class="btn btn-primary mr-2" type="submit">Submit</button>
            <button class="btn btn-secondary" @click.prevent="backProPage">
              Back
            </button>
          </div>
        </form>

        <!-- 桌機板裁切工具 Modal  -->
        <div id="cropImagePop" class="modal fade" tabindex="-1" role="dialog">
          <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
              <div class="modal-header d-flex justify-content-between">
                <div class="modal-title" style="font-size: 25px">
                  <div class="d-flex align-self-center">
                    <div class="mr-3">
                      <img
                        src="../../../assets/images/cropImg.png"
                        width="30px"
                      />
                    </div>
                    <div style="font-size: 25px">Edit Image</div>
                  </div>
                </div>
                <div
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </div>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-sm-8">
                    <div class="CropBoxStyle">
                      <vue-cropper
                        ref="cropper"
                        :img="option.img"
                        :output-size="option.size"
                        :output-type="option.outputType"
                        :info="true"
                        :full="option.full"
                        :fixed="fixed"
                        :can-move="option.canMove"
                        :can-move-box="option.canMoveBox"
                        :fixed-box="option.fixedBox"
                        :original="option.original"
                        :auto-crop="option.autoCrop"
                        :auto-crop-width="option.autoCropWidth"
                        :auto-crop-height="option.autoCropHeight"
                        :center-box="option.centerBox"
                        :high="option.high"
                        :max-img-size="option.max"
                        :fixed-number="fixedNumber"
                        :enlarge="option.enlarge"
                        :infoTrue="option.infoTrue"
                        :mode="option.mode"
                        @real-time="realTime"
                      >
                      </vue-cropper>
                    </div>

                    <div class="d-flex justify-content-between mt-3 mx-3">
                      <div>
                        <button @click="rotateLeft" class="btn btn-info">
                          Rotate Left
                        </button>
                        <button @click="rotateRight" class="btn btn-info ml-2">
                          Rotate Right
                        </button>
                        <button
                          @click="changeScale(1)"
                          class="btn btn-info ml-2"
                        >
                          +
                        </button>
                        <button
                          @click="changeScale(-1)"
                          class="btn btn-info ml-2"
                        >
                          -
                        </button>
                      </div>
                      <div>
                        <button
                          @click="refreshCrop"
                          class="btn btn-outline-info ml-5"
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <div :style="previewStyle1" class="ImgPreCrop">
                      <div :style="previews.div">
                        <img :src="previews.url" :style="previews.img" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <hr />
              <div class="modal-footer">
                <div>
                  <button
                    type="button"
                    id="cropImageBtn"
                    class="btn btn-lg btn-primary mr-2"
                    @click="OutputEnPC()"
                  >
                    Crop
                  </button>

                  <button
                    type="button"
                    class="btn btn-lg btn-secondary"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 行動版裁切工具 Modal  -->
        <div
          class="modal fade"
          id="cropperMb"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div
            class="modal-dialog modal-sm modal-dialog-centered"
            role="document"
          >
            <div class="modal-content">
              <div class="modal-body">
                <p>
                  &middot; Automatically resize your image into square image.
                </p>
                <p>
                  &middot; If you need to crop or edit your image, please use
                  the computer to upload your image.
                </p>
              </div>

              <div class="modal-footer">
                <button
                  type="button"
                  id="cropperMb"
                  class="btn btn-sm btn-primary"
                  @click="OutputEnMb()"
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- 產品分類彈跳視窗 -->
        <div
          class="modal fade"
          id="SearchModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLongTitle"
          aria-hidden="true"
          style="z-index: 5000"
        >
          <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
              <div
                class="modal-header modal-title-bg"
                style="background-color: #f5f7fa"
              >
                <h4
                  class="modal-title"
                  style="font-size: 25px"
                  id="exampleModalLongTitle"
                >
                  Select Product Category
                </h4>

                <div
                  type="button"
                  class="modal-close pointer"
                  data-dismiss="modal"
                  aria-label="Close"
                  style="font-size: 28px; font-weight: bold"
                >
                  <span aria-hidden="true">&times;</span>
                </div>
              </div>
              <div class="modal-body">
                <div class="mb-3 mt-2">
                  <div class="mb-4">
                    <el-collapse v-model="Tab_Category">
                      <el-collapse-item
                        v-for="(item, parentIndex) in ProductCategory"
                        :key="parentIndex"
                        :title="`${parentIndex + 1}. ${
                          item.MainCategoryNameEn
                        }`"
                        :name="parentIndex"
                      >
                        <div class="row">
                          <div
                            class="col-lg-6 my-1"
                            v-for="(Category, childIndex) in item.SubCategory"
                            :key="childIndex"
                          >
                            <div class="custom-control custom-radio">
                              <input
                                type="radio"
                                name="checkAll"
                                class="custom-control-input"
                                :value="Category.CategoryId"
                                :id="Category.CategoryId"
                                v-model="SelectedCatId"
                              />
                              <label
                                class="custom-control-label CategoryPointer"
                                :for="Category.CategoryId"
                                >{{ Category.CategoryNameEn }}</label
                              >
                            </div>
                          </div>
                        </div>
                      </el-collapse-item>
                    </el-collapse>
                  </div>
                </div>
              </div>

              <div class="modal-footer" style="display: inline">
                <div class="d-flex justify-content-end align-items-center">
                  <button
                    type="button"
                    id="cropImageBtn"
                    class="btn btn-lg btn-primary mr-2"
                    @click="confirmCategory"
                  >
                    Confirm
                  </button>
                  <button
                    type="button"
                    class="btn btn-lg btn-secondary"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="showImg" class="CropBoxStyle">
          <vue-cropper
            ref="cropper"
            :img="option.img"
            :output-size="option.size"
            :output-type="option.outputType"
            :info="true"
            :full="option.full"
            :fixed="fixed"
            :can-move="option.canMove"
            :can-move-box="option.canMoveBox"
            :fixed-box="option.fixedBox"
            :original="option.original"
            :auto-crop="option.autoCrop"
            :auto-crop-width="option.autoCropWidth"
            :auto-crop-height="option.autoCropHeight"
            :center-box="option.centerBox"
            :high="option.high"
            :max-img-size="option.max"
            :fixed-number="fixedNumber"
            :enlarge="option.enlarge"
            :infoTrue="option.infoTrue"
            :mode="option.mode"
          >
          </vue-cropper>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  metaInfo() {
    return {
      title: `Products - Chan Chao Exhibitor's Online Service System`,
    };
  },

  data() {
    return {
      HasSubCategory: false,
      showCategory: "",
      SelectedCatId: null,
      showImg: false,
      CSRF_Token: "",
      RegNo: "",
      ProductWarning: "",
      ProductCategory: [],
      ProTwoCatList: [],
      hasProTwoCat: false,
      optionCatNo: "", //產品類別號碼
      productArchive: 0,
      ProName: "",
      eProName: "",
      ProModel: "",
      ProDesc: "", //產品說明
      eProDesc: "",
      ProImg: "",
      modelSrc: "../../../assets/images/default.jpg",
      noImageSrc: "../../../assets/images/default.jpg",

      modelEnSrc: "../../../assets/images/default.jpg",
      noImageEnSrc: "../../../assets/images/default.jpg",

      previews: {},
      previewStyle1: {},
      lang: "en",

      LocalExh: true,

      option: {
        img: "", // 裁剪图片的地址V
        max: 9999, //限制图片最大宽度和高度
        enlarge: 1, //图片根据截图框输出比例倍数
        mode: "contain",

        centerBox: false, // 截图框是否被限制在图片里面
        canMove: true, //上传图片是否可以移动
        infoTrue: true,

        fixedBox: true, // 固定截图框大小 不允许改变
        canMoveBox: false, // 截图框能否拖动
        autoCrop: true, // 是否默认生成截图框
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 500, // 默认生成截图框宽度
        autoCropHeight: 500,

        full: true, //是否输出原图比例的截图，X匯出等比例(長型就匯長型)
        high: true, //是否按照设备的dpr 输出等比例图片，X匯出等比例(長型就匯長型)
        original: true, // 上传图片按照原始比例渲染

        size: 1, //裁剪生成图片的质量V
        outputType: "webp", // 裁剪生成图片的格式V
      },

      fixed: true, // 是否开启截图框宽高固定比例
      fixedNumber: [1, 1], // 截图框的宽高比例

      hasImgfile: false,

      Tab_Category: [0],
      SelectCatName: "",
      MainCatName: "",
      selectedCategoryName: "",
    };
  },

  watch: {
    SelectedCatId(newVal) {
      if (!newVal) return;

      const found = this.ProductCategory.flatMap(
        (main) => main.SubCategory,
      ).find((sub) => sub.CategoryId === String(newVal));

      if (found) {
        this.selectedCategoryName = found.CategoryNameEn;
      } else {
        this.selectedCategoryName = "";
      }
    },
    optionCatNo: function (newValue) {
      let ShowName = this.ProductCategory.filter(function (item) {
        return item.CatNo == newValue;
      });

      this.SelectCatName = ShowName[0].CatName;

      let GetCatName = this.ProTwoCatList.filter(function (item) {
        return item.subCategory.find(function (item2) {
          return item2.CatNo == newValue;
        });
      });

      this.MainCatName = GetCatName[0].mainCatName;

      $("#SelectCatModal").modal("hide");
    },
  },

  methods: {
    confirmCategory() {
      const vm = this;

      if (vm.SelectedCatId) {
        vm.showCategory = vm.selectedCategoryName;
        $("#SearchModal").modal("hide");
        vm.optionCatNo = vm.SelectedCatId;
      } else {
        $("#SearchModal").modal("hide");
      }
    },
    OpenCategoryModal() {
      $("#SearchModal").modal("show");
    },
    handleClick(tab) {
      const vm = this;

      if (tab.index == "0") {
        vm.SelectCategory = this.$t("SearchList.Category");
        vm.SelectBtn = "Category";
      } else if (tab.index == "1") {
        vm.SelectCategory = this.$t("SearchList.Category");
        vm.SelectBtn = "Keyword";
      }
    },
    resetEnImg() {
      const vm = this;
      vm.modelEnSrc = "../../../assets/images/default.jpg";
      vm.hasImgfile = false;
    },

    AddEnNewProduct() {
      const vm = this;
      const url = "/apiExhibitors/Product/";

      const info = {
        RegNo: vm.RegNo,
        ProImg: vm.modelEnSrc,
        category: vm.optionCatNo,
        ProName: vm.ProName,
        eProName: vm.eProName,
        ProModel: vm.ProModel,
        ProDesc: vm.ProDesc,
        eProDesc: vm.eProDesc,
        Archived: vm.productArchive,
        CSRF: vm.CSRF_Token,
      };

      // console.log(info)

      if (vm.modelEnSrc == "../../../assets/images/default.jpg") {
        alert("Must provide image, please check again！ ");
      } else {
        if (!vm.optionCatNo || !vm.eProName || !vm.eProDesc) {
          alert("There are incomplete fields, please check again.");
        } else {
          axios.post(url, info).then(function (response) {
            if (response.data.Code == 200) {
              // alert('Successfully published your new product！')
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/product?no=${vm.RegNo}`;
            } else if (response.data.Code == 251 || response.data.Code == 500) {
              alert("System is busy, please try again later.");
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/product?no=${vm.RegNo}`;
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`;
            } else if (response.data.Code == 253) {
              alert("Image upload failed！ ");
            } else if (response.data.Code == 254) {
              alert("You have reached the maximum upload limit.");
              document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/product?no=${vm.RegNo}`;
            }
          });
        }
      }
    },

    uploadImgPC(e) {
      const vm = this;

      var file = e.target.files[0];
      if (!/\.(jpg|jpeg|JPG|JPEG|webp|WEBP)$/.test(e.target.value)) {
        alert("上傳檔案類型必須是 JPG 或 WebP！");
        return false;
      }

      var reader = new FileReader();

      reader.onload = (e) => {
        const isLt5M = e.total / 1024 / 1024 < 3;
        if (isLt5M) {
          $("#cropImagePop").modal("show");

          $("#cropImagePop").on("shown.bs.modal", function () {
            vm.option.img = window.URL.createObjectURL(
              new Blob([e.target.result]),
            );
          });
        } else {
          alert("上傳圖片大小請勿超過 3MB！");
        }
      };

      reader.readAsArrayBuffer(file);
      e.target.value = "";
    },

    uploadImgMb(e) {
      const vm = this;

      var file = e.target.files[0];
      if (!/\.(jpg|jpeg|JPG|JPEG|webp|WEBP)$/.test(e.target.value)) {
        alert("Upload file must be in JPG or WebP！ ");
        return false;
      }
      var reader = new FileReader();
      reader.readAsArrayBuffer(file);

      reader.onload = (e) => {
        const isLt5M = e.total / 1024 / 1024 < 3;

        if (isLt5M) {
          this.option.img = window.URL.createObjectURL(
            new Blob([e.target.result]),
          );
          vm.showImg = true;
          $("#cropperMb").modal("show");
        } else {
          alert("Maximum file size : 3MB");
        }
      };

      e.target.value = "";
    },

    OutputPC() {
      const vm = this;

      this.$refs.cropper.getCropData((data) => {
        // console.log(data)
        this.modelSrc = data;
        $("#cropImagePop").on("hidden.bs.modal", function (e) {
          vm.hasImgfile = true;
          vm.option.img = "/";
        });
        $("#cropImagePop").modal("hide");

        window.setTimeout(
          () =>
            alert(
              "恭喜您成功上傳圖片，請接續填寫產品資訊並按下「確認新增」鍵，即可完成新增產品之程序。",
            ),
          1000,
        );
      });
    },

    OutputEnPC() {
      const vm = this;

      this.$refs.cropper.getCropData((data) => {
        // console.log(data)
        this.modelEnSrc = data;
        $("#cropImagePop").on("hidden.bs.modal", function (e) {
          vm.hasImgfile = true;
          vm.option.img = "/";
        });
        $("#cropImagePop").modal("hide");

        window.setTimeout(
          () =>
            alert(
              'The picture uploaded successfully. Please also fill out the product information required, and click "Submit" to complete the process.',
            ),
          1000,
        );
      });
    },

    OutputMb() {
      // 输出
      const vm = this;

      this.$refs.cropper.getCropData((data) => {
        // console.log(data)
        this.modelSrc = data;
      });

      $("#cropperMb").modal("hide");
      vm.showImg = false;
    },

    OutputEnMb() {
      // 输出
      const vm = this;

      this.$refs.cropper.getCropData((data) => {
        // console.log(data)
        this.modelEnSrc = data;
      });

      $("#cropperMb").modal("hide");
      vm.showImg = false;
    },

    // 实时预览函数
    realTime(data) {
      var previews = data;
      var h = 0.5;
      var w = 0.2;

      this.previewStyle1 = {
        width: previews.w + "px",
        height: previews.h + "px",
        overflow: "hidden",
        margin: "0",
        zoom: h,
      };

      this.previews = data;
    },

    rotateLeft() {
      this.$refs.cropper.rotateLeft();
    },
    rotateRight() {
      this.$refs.cropper.rotateRight();
    },

    changeScale(num) {
      num = num || 1;
      this.$refs.cropper.changeScale(num);
    },

    refreshCrop() {
      this.$refs.cropper.refresh();
    },

    backProPage() {
      const vm = this;
      if (vm.lang == "tw") {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/product?no=${vm.RegNo}`;
      } else {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/product?no=${vm.RegNo}`;
      }
    },
  },

  created() {
    const vm = this;

    $("body").tooltip({ selector: "[data-toggle=tooltip]" });

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1].split("&")[0];

    //取得產品類別列表
    let url = `/apiExhibitors/ProductCategory/${vm.RegNo}`;
    axios.get(url).then(function (response) {
      vm.ProductCategory = response.data.Data.ProductMainCategory;
      vm.HasSubCategory = response.data.Data.HasSubCategory;
      // 取得產品欄位警語
    });

    //取得產品欄位警語
    axios
      .get(`/apiExhibitors/ProductWarning/${vm.RegNo}?lang=${vm.lang}`)
      .then(function (response) {
        vm.ProductWarning = response.data.Data.ProductWarning;
      });

    //取得產品類別列表
    let url2 = `/apiExhibitors/ProductCategoryTwoLayer/${vm.RegNo}`;
    axios.get(url2).then(function (response) {
      if (response.data.Code == 200) {
        vm.ProTwoCatList = response.data.Data;
        vm.hasProTwoCat = true;
      } else {
        vm.hasProTwoCat = false;
      }
    });

    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=tw`,
      )
      .then((response) => {
        if (response.data.Code == 200) {
          let ExpoLocation = response.data.Data.ExpoLocation;

          if (ExpoLocation === "T" || ExpoLocation === null) {
            vm.LocalExh = true;
          } else {
            vm.LocalExh = false;
          }
        } else if (response.data.Code == 404) {
          // console.log('查無資料')
        } else {
          alert("The system is busy, please try again later");
        }
      });
  },
};
</script>

<style lang="scss">
.form-control {
  height: calc(2.2em + 0.75rem + 2px);
}

// @media screen and (min-width: 331px) and (max-width: 576px) {
//   .modal-content {
//     width: 65%;
//   }
// }

// @media screen and (max-width: 330px) {
//   .modal-content {
//     width: 60%;
//   }
// }

.modal-xl {
  max-width: 940px;
}

.proRight {
  border-left: 0px solid #dadce0;
}

.proLeft {
  padding-right: 0px;
}

.uncomplete {
  background-image: url("../../../assets/images/tickGray.svg");
  width: 18px;
  height: 18px;
  display: inline-block;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: auto 100%;
  padding-left: 20px;
}

.complete {
  background-image: url("../../../assets/images/tick.svg");
  width: 18px;
  height: 18px;
  display: inline-block;
  background-repeat: no-repeat;
  background-position: left center;
  background-size: auto 100%;
  padding-left: 20px;
}

.modal-body {
  height: 75vh;
  overflow-y: auto;
}

.custom-control-label {
  font-size: 15px;
}

@media screen and (max-width: 800px) {
  .el-collapse-item__header {
    font-size: 14px;
    font-weight: 550;

    height: 70px;
    line-height: 18px;
  }
}

@media screen and (min-width: 801px) {
  .el-collapse-item__header {
    font-size: 17px;
    font-weight: 550;
    height: 60px;
    line-height: 25px;
  }
}
</style>
